import { useTranslation } from 'react-i18next';

const DEFAULT_NUMBER = '212600000000';

function sanitizeNumber(raw: string): string {
  return raw.replace(/[^\d]/g, '');
}

export function WhatsAppButton() {
  const { t } = useTranslation();
  const envNumber = import.meta.env.VITE_WHATSAPP_NUMBER as string | undefined;
  const number = sanitizeNumber(envNumber || DEFAULT_NUMBER);
  const message = t('whatsapp.message');
  const href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsapp.aria')}
      className="fixed bottom-6 start-6 z-40 inline-flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-transform hover:scale-105 active:scale-95"
      style={{ backgroundColor: '#25D366', color: '#FFFFFF' }}
    >
      <svg
        viewBox="0 0 32 32"
        className="w-7 h-7"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M16.003 3C9.374 3 4 8.374 4 15c0 2.366.69 4.57 1.879 6.43L4 29l7.78-1.84A11.94 11.94 0 0 0 16.003 27C22.633 27 28 21.628 28 15S22.633 3 16.003 3zm6.957 16.91c-.29.815-1.69 1.557-2.331 1.65-.594.09-1.346.128-2.17-.135-.5-.156-1.142-.367-1.965-.722-3.459-1.49-5.715-4.94-5.887-5.168-.171-.227-1.403-1.865-1.403-3.56s.89-2.527 1.205-2.871c.314-.343.685-.43.913-.43.229 0 .457.002.657.012.21.01.493-.08.77.587.29.685.984 2.37 1.07 2.541.086.171.143.371.029.6-.114.228-.171.371-.343.571-.171.2-.36.448-.514.6-.171.171-.35.357-.15.7.2.343.89 1.467 1.91 2.376 1.312 1.166 2.418 1.526 2.762 1.697.343.171.543.143.743-.085.2-.228.857-1 1.085-1.343.228-.343.457-.286.771-.171.314.114 1.99.94 2.331 1.111.343.171.572.257.657.4.086.143.086.815-.204 1.63z" />
      </svg>
    </a>
  );
}
